import React from "react";

const gstData = [
  { id: "01.", state: "Ministry of Corporate Affairs", url: "https://www.mca.gov.in" },
  { id: "02.", state: "National Company Law Tribunal", url: "https://nclt.gov.in" },
  { id: "03.", state: "Reserve Bank of India", url: "https://www.rbi.org.in" },
  { id: "04.", state: "Securities and Exchange Board of India", url: "https://www.sebi.gov.in" },
  { id: "05.", state: "Bombay Stock Exchange Limited", url: "https://www.bseindia.com" },
  { id: "06.", state: "National Stock Exchange of India Limited", url: "https://www.nseindia.com" },
  { id: "07.", state: "National Securities Depositories Limited", url: "https://nsdl.co.in/" },
  { id: "08.", state: "Central Depository Services (India) Limited", url: "https://www.cdslindia.com" },
  { id: "09.", state: "Institute of Company Secretaries, India (ICSI)", url: "https://www.icsi.edu" },
  { id: "10.", state: "Institute of Chartered Accountants of India (ICAI)", url: "https://www.icai.org" },
  { id: "11.", state: "Institute of Cost and Works Accountants of India (ICMAI)", url: "https://www.icmai.in" },
  { id: "12.", state: "Ministry of Commerce and Industry", url: "http://dipp.nic.in/" },
  { id: "13.", state: "Ministry of Finance", url: "https://www.finmin.nic.in" },
  { id: "14.", state: "Income Tax Department", url: "https://www.incometaxindia.gov.in/" },
  { id: "15.", state: "Goods and Service Tax", url: "https://www.gst.gov.in" },
  { id: "16.", state: "Foreign Investment Promotion Board (DPIIT)", url: "https://fifp.gov.in/" },
  { id: "17.", state: "Insolvency and Bankruptcy Board of India", url: "https://www.ibbi.gov.in" },
  { id: "18.", state: "Indian Institute of Insolvency Professionals of ICAI", url: "https://www.icsiiip.com" },
  { id: "19.", state: "ICSI Institute of Insolvency Professionals", url: "https://iip.icsi.edu" },
];

export default function GstVat() {
  return (
    <div
      className="gstvat-wrapper"
      style={{
        padding: "100px 20px 40px",
        fontFamily: "Arial, sans-serif"
      }}
    >
      <div className="max-w-[1100px] mx-auto" style={{ maxWidth: "1100px", margin: "0 auto" }}>

        {/* Header */}
        <div
          className=" gst-header px-4 py-4 sm:px-5 sm:py-5"
          style={{
            background: "#f0f7ff",
            border: "1px solid #d1d5db",
            borderRadius: "8px",
            padding: "20px",
            textAlign: "center",
            marginBottom: "25px",
            boxShadow: "0 2px 5px rgba(0,0,0,0.05)"
          }}
        >
          <h2 style={{ color: "#1a3c6e", margin: 0, fontSize: "22px", fontWeight: "700", textTransform: "uppercase" }}>
            Goods and Service Tax Website of Indian States
          </h2>
        </div>

        {/* TABLE CONTAINER (MOBILE FIX) */}
        <div
          style={{ border: "1px solid #e5e7eb", borderRadius: "8px", overflowX: "auto" }}
        >
          <table
            className="min-w-[600px]"
            style={{
              width: "100%",
              borderCollapse: "collapse",
              backgroundColor: "#fff",
              textAlign: "left"
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "#f3f4f6" }}>
                <th style={styles.th}>S. No.</th>
                <th style={styles.th}>State</th>
                <th style={{ ...styles.th, borderRight: "none" }}>Website</th>
              </tr>
            </thead>

            <tbody>
              {gstData.map((item, index) => (
                <tr key={index} style={{ borderBottom: "1px solid #e5e7eb" }}>

                  <td className="whitespace-nowrap" style={{ ...styles.td, width: "70px" }}>
                    {item.id}
                  </td>

                  <td className="whitespace-nowrap sm:whitespace-normal" style={{ ...styles.td, width: "300px" }}>
                    {item.state}
                  </td>

                  <td className="whitespace-nowrap" style={{ ...styles.td, borderRight: "none" }}>
                    <a
                      href={item.url.startsWith('http') ? item.url : `https://${item.url}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="break-all"
                      style={{ color: "#1d4ed8", textDecoration: "none" }}
                    >
                      {item.url}
                    </a>
                  </td>

                </tr>
              ))}
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
}

const styles = {
  th: {
    padding: "15px",
    fontSize: "15px",
    fontWeight: "700",
    color: "#374151",
    borderBottom: "1px solid #e5e7eb",
    borderRight: "1px solid #e5e7eb",
    backgroundColor: "#f9fafb"
  },
  td: {
    padding: "12px 15px",
    fontSize: "14px",
    color: "#4b5563",
    borderRight: "1px solid #e5e7eb"
  }
};